// src/components/directory/DirectoryFilters.js

const categories = ["Agent", "Authors", "Distributors", "Editors", "Illustrators", "Marketing", "Platforms", "Printers", "Publishers", "Stockists"].sort();

const DirectoryFilters = ({ searchTerm, selectedCategory, onSearchChange, onCategoryChange }) => {
    // Ana div'e 'filter-panel' sınıfı ekleniyor
    return (
        <div className="filter-panel">
            <div className="row g-3 align-items-center">
                <div className="col-lg-8">
                    <input 
                        type="text" 
                        className="form-control form-control-lg" 
                        placeholder="Search by name or location..." 
                        value={searchTerm} 
                        onChange={onSearchChange} 
                    />
                </div>
                <div className="col-lg-4">
                    <select 
                        className="form-select form-select-lg" 
                        value={selectedCategory} 
                        onChange={onCategoryChange}
                    >
                        <option value="All">All Categories</option>
                        {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                </div>
            </div>
        </div>
    );
};

export default DirectoryFilters;